<template>
  <div>
    <b-row>
      <b-col cols="12" class="mb-2">
        <h2 class="mb-0 text-uppercase font-weight-bolder">étape 2 : recueil des besoins</h2>
        <h6>Renseignez les besoins exprimés</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <sante-tns-component v-if="getRisqueStatut('SANTETNS')" ref="saisieTNS" />
        <sante-seniors-component v-else-if="getRisqueStatut('SANTESENIORS')" ref="saisieSanteSenior" />
        <deux-roues-component v-else-if="getRisqueStatut('2-ROUES')" ref="saisie2Roues" />
        <emprunteur-component v-else-if= "getRisqueStatut('EMPRUNTEUR')" ref="saisieEmprunteur" />
        <protection-juridique-component v-else-if= "getRisqueStatut('PROTECTIONJURIDIQUE')" ref="saisieProtectionJuridique" />
        <ijh-component v-else-if= "getRisqueStatut('INDEMNITEJOURNALIEREHOSPITALIERE')" ref="saisieIJH" />
        <Accident-Deces-component v-else-if= "getRisqueStatut('DECES')" ref="saisiedeces" />
        <SanteActifs v-else-if="getRisqueStatut('SANTEACTIFS')" ref="saisieSanteActifs"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import SanteTnsComponent from './BesoinsSanteTns.vue'
import SanteSeniorsComponent from './BesoinsSanteSenior.vue'
import DeuxRouesComponent from './Besoins2Roues.vue'
import EmprunteurComponent from './BesoinEmprunteur.vue'
import AccidentDecesComponent from './BesoinAccidentDeces.vue'
import ProtectionJuridiqueComponent from './BesoinsProtectionJuridique.vue'
import IjhComponent from './BesoinsIJH.vue'
import SanteActifs from './BesoinSanteActifs.vue'

export default {
  components: {
    // UI
    SanteTnsComponent,
    SanteSeniorsComponent,
    DeuxRouesComponent,
    EmprunteurComponent,
    AccidentDecesComponent,
    ProtectionJuridiqueComponent,
    IjhComponent,
    SanteActifs,
    // BTV
    BRow,
    BCol,
  },
  computed: {
    ...mapGetters(['getQWCheckedRisque'])
  },
  methods: {
    getRisqueStatut(value) {
      return (value && this.getQWCheckedRisque) ? this.formatText(this.getQWCheckedRisque) == value : ''
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
